import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '@app/@core/services/http.service';
import { LocalService } from '@app/@core/services/local.service';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { PageBuilderAddURL } from '@app/pages/page-builder/page-builder/page-builder-add/@core/page-builder-add-url.config';

@Injectable({
  providedIn: 'root'
})
export class PageBuilderAddService {
  authorisedTabs: MenuItem[] = [];
  private cachedFiles = {};
  private cachedData = {};
  private cachePrevious: any;

  constructor(
    private httpService: HttpService,
    private router: Router,
    private httpClient: HttpClient,
    private localstore: LocalService
  ) {
    // This is intentional
  }

  public getFormData = new BehaviorSubject<any>('');
  currentFormData = this.getFormData.asObservable();

  private refreshDocumentHistorySource = new Subject<void>();
  refreshDocumentHistory$ = this.refreshDocumentHistorySource.asObservable();

  triggerRefresh() {
    this.refreshDocumentHistorySource.next();
  }

  setFormData(data) {
    this.getFormData.next(data);
  }

  public getBasicData = new BehaviorSubject<any>('');
  currentBasicData = this.getBasicData.asObservable();

  setBasicData(data) {
    this.getBasicData.next(data);
  }

  public getPageType = new BehaviorSubject<any>(this.localstore.getObj('SELECTED_PAGE'));
  currentPageType = this.getPageType.asObservable();

  setPageType(data: string) {
    this.getPageType.next(data);
  }

  clearCacheForKey(key) {
    delete this.cachedData[key];
  }

  getBasicDetailsbyId(id) {
    return this.httpService.get(PageBuilderAddURL.EndPoints.page_config.pageVersion.replace('{id}', id));
  }
  pageAlertChecking(pagename: any, orgid: any, _body?: any) {
    return this.httpService.post(
      PageBuilderAddURL.EndPoints.page_config.pageExist
        .replace('{pagename}', String(pagename))
        .replace('{orgid}', String(orgid)),
      _body
    );
  }

  createPage(data: any) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.page_config.page + '/', data);
  }
  createAssetByVersion(pageid: any, versionid: any, assetData: any) {
    return this.httpService.post(
      PageBuilderAddURL.EndPoints.page_config.assetByVersion
        .replace('{pageid}', String(pageid))
        .replace('{versionid}', String(versionid)),
      assetData
    );
  }

  getMenuList(data, id) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.rbac.asset.batch + id, data);
  }

  getTableFields(param1, param2) {
    return this.httpService.get(PageBuilderAddURL.EndPoints.page_config.dbSchema + param1 + '/' + param2 + '/true/');
  }

  createReportTable(data) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.report.report + '/', data);
  }

  getAllPage(url) {
    return this.httpService.get(url);
  }

  getSchema() {
    return this.httpService.get(PageBuilderAddURL.EndPoints.page_config.dbSchema);
  }

  getAllOrganisations() {
    return this.httpService.get(PageBuilderAddURL.EndPoints.rbac.organization.list + 'all');
  }

  editPageStatus(data, id) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.page_config.page_lock.replace('{id}', String(id)), data);
  }

  getOrgList(orgid) {
    return this.httpService.get(PageBuilderAddURL.EndPoints.page_config.orgPageList.replace('{orgid}', orgid));
  }

  getUploadAndUrl(file, payload) {
    const fd = new FormData();
    fd.append('file', file);
    Object.keys(payload)
      .filter(k => !!payload[k])
      .forEach(k => {
        fd.append(k, payload[k]);
      });
    return this.httpService.post(PageBuilderAddURL.EndPoints.attachment.uploadFile, fd);
  }

  getUploadKey(data) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.attachment.uploadKey, data);
  }

  getFormResponseAttachment(formid, responseid) {
    if (this.cachedFiles[`f-${formid}-${responseid}`]) {
      return of(this.cachedFiles[`f-${formid}-${responseid}`]);
    }
    return this.httpService
      .get(PageBuilderAddURL.EndPoints.attachment.list.replace('{formid}', formid).replace('{responseid}', responseid))
      .pipe(
        tap(response => {
          this.cachedFiles[`f-${formid}-${responseid}`] = response;
        })
      );
  }

  clearCache() {
    this.cachedFiles = {};
    this.cachedData = {};
  }

  deleteFormResponseAttachment(fileid) {
    return this.httpService.delete(PageBuilderAddURL.EndPoints.attachment.delete.replace('{fileid}', fileid));
  }

  downloadFormResponseAttachment(data) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.attachment.downloadKey, data);
  }
  returnToList() {
    this.router.navigate(['/pages/page-design/list']);
  }

  getDocumentViewLink(payload: any) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.attachment.documentView, payload);
  }

  deleteDocument(payload: any) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.attachment.deleteDocument, payload);
  }

  clearCacheByKey(cacheKey: string) {
    console.log(this.cachedData[cacheKey],this.cachedData,'cachedData')
    delete this.cachedData[cacheKey];
  }

  getGridResult(pageid: string, query: string, fieldName: string = '', withResult = false) {
    const cacheKey = window.btoa(query + '-' + fieldName);
    if (this.cachedData[cacheKey]) {
      return of(this.cachedData[cacheKey]);
    }
    const payload = {
      query
    };
    let url = `${PageBuilderAddURL.EndPoints.page_config.gridPageResult.replace('{id}', pageid)}`;
    if (withResult) {
      url += '?withResult=true';
    }
    return this.httpService.post(url, payload).pipe(tap(response => (this.cachedData[cacheKey] = response)));
  }

  getGridResultCount(pageid: string, query: string, fieldName: string = '') {
    const cacheKey = `count-${window.btoa(query + '-' + fieldName)}`;
    if (this.cachedData[cacheKey]) {
      return of(this.cachedData[cacheKey]);
    }
    const payload = {
      query
    };
    return this.httpService
      .post(`${PageBuilderAddURL.EndPoints.page_config.gridPageResultCount.replace('{id}', pageid)}`, payload)
      .pipe(tap(response => (this.cachedData[cacheKey] = response)));
  }

  getFormPage(pageid: string) {
    return this.httpService.get(`${PageBuilderAddURL.EndPoints.page_config.formPage.replace('{id}', pageid)}`);
  }

  submitForm(formData: any) {
    return this.httpService.post(`${PageBuilderAddURL.EndPoints.page_config.submitForm}`, formData);
  }

  getMember(id, pageId) {
    return this.httpService.get(
      `${PageBuilderAddURL.EndPoints.page_config.getMember.replace('{id}', id).replace('{pageId}', pageId)}`
    );
  }

  editForm(formData: any, id) {
    return this.httpService.patch(
      `${PageBuilderAddURL.EndPoints.page_config.updateForm.replace('{id}', id)}`,
      formData
    );
  }

  deleteRow(id, pageId) {
    return this.httpService.delete(
      `${PageBuilderAddURL.EndPoints.page_config.deleteRow.replace('{id}', id).replace('{pageId}', pageId)}`
    );
  }

  getDocumentsHistory(responseId, formId) {
    const cacheKey = `documents-${responseId}-${formId}`;
    if (this.cachedData[cacheKey]) {
      return of(this.cachedData[cacheKey]);
    }
    const url = PageBuilderAddURL.EndPoints.documents.history
      .replace('{responseid}', responseId)
      .replace('{formId}', formId);
    return this.httpService.get(url).pipe(tap(response => (this.cachedData[cacheKey] = response)));
  }


  getFormioJson(assessmentid: number) {
    return this.httpService.get(PageBuilderAddURL.EndPoints.assessments.getFormioJson + '/' + assessmentid);
  }

  submitNestedForm(formData: any) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.assessments.createNestedFormResponse, formData);
  }

  updateNestedForm(requestData: any, id: number) {
    return this.httpService.patch(
      PageBuilderAddURL.EndPoints.assessments.updateNestedFormResponse.replace('{formId}', id.toString()),
      requestData
    );
  }

  createFormResponseAttachment(data) {
      return this.httpService.post(PageBuilderAddURL.EndPoints.attachment.createAttachment, data);
  }

  clearCacheFileByKey(key:any){
    delete this.cachedFiles[key];
  }

  markDocumentDeficient(body: any) {
    return this.httpService.post('/application-flow/notes/mark-deficient', body);
  }

  post(endPoint, body) {
    return this.httpService.post(endPoint,body);
  }
}
